<template>
  <div>
    <div class="logo-wrapper">
      <Logo />
      <div class="back-btn" @click="toggle_sidebar">
        <vue-feather type="chevron-left" size="16"></vue-feather>
      </div>
      <div class="toggle-sidebar" @click="toggle_sidebar">
        <vue-feather
          class="status_toggle middle sidebar-toggle"
          type="grid"
          id="sidebar-toggle"
        ></vue-feather>
      </div>
    </div>

    <div class="logo-icon-wrapper">
      <router-link to="/">
        <img
          class="img-fluid"
          src="../../assets/images/logo/logo-icon.png"
          alt=""
      /></router-link>
    </div>

    <Nav />
    
  </div>
</template>

<script>
  import Logo from './logo.vue';
  import Nav from './nav.vue';
  import { useMenuStore } from '@/stores/menu';
  import { storeToRefs } from 'pinia';

  export default {
    name: 'Sidebar',
    components: {
      Logo,
      Nav,
    },
    setup() {
      const menuStore = useMenuStore();
      const { data, activeoverlay } = storeToRefs(menuStore);

      function toggle_sidebar() {
        // call action
        menuStore.opensidebar();
      }

      return {
        menuStore,
        menuItems: data,
        activeoverlay,
        toggle_sidebar,
      };
    },
  };
</script>
